import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";
import { dateFormatter } from "../framework/dateFormatter";
import { forms } from "../framework/forms";

function init() {
    $(document).on("click", "#AddTagBtn", function() {
        const $btn = $(this);

        if ($("#TagId").find("option").length === 0) {
            $("#TagErrorMessage").show();
        } else {
            const data = {
                personId: $btn.data("personid"),
                tagId: $("#TagId").val()
            };

            const params = {
                "data": data,
                "url": "/Person/AddTag"
            };

            forms.showSpinner("Saving...", false);

            dataaccess.post(params).done(function(results) {
                showResults(results);
            }).always(function() {
                forms.hideSpinner();
            });
        }
    });

    $(document).on("click", ".js-tag-edit", function() {
        const $row = $(this).closest("div");
        $row.find("button, .js-tag-dates").toggle();
    });

    $(document).on("click", ".js-tag-cancel", function() {
        const $row = $(this).closest("div");
        $row.find("button, .js-tag-dates").toggle();
    });

    $(document).on("click", ".js-tag-delete", function() {
        if (window.confirm("Are you sure you want to delete this person's tag?")) {
            const personId = $(this).data("personid");
            const personTagId = $(this).data("id");

            forms.showSpinner("Deleting...", false);

            dataaccess.delete({ url: `/person/${personId}/persontag/${personTagId}` }).done(function(results) {
                showResults(results);
            }).always(function() {
                forms.hideSpinner();
            });
        }
    });

    $(document).on("click", ".js-tag-save", function() {
        const personTagId = $(this).data("id");
        const $row = $(this).closest("div");
        const startDate = $row.find(".js-start-date").val();
        const endDate = $row.find(".js-end-date").val();

        if (startDate === "") {
            $row.find(".field-validation-error").show();
            return;
        } else {
            $row.find(".field-validation-error").hide();
        }

        if (new Date(startDate) >= new Date(endDate)) {
            $row.find(".js-date-range-error").show();
            return;
        } else {
            $row.find(".js-date-range-error").hide();
        }

        const parameters = {
            data: {
                startDateUtc: startDate,
                endDateUtc: endDate
            },
            url: "/persontag/" + personTagId
        };

        forms.showSpinner("Saving...", false);

        dataaccess.put(parameters).done(function(results) {
            showResults(results);
        }).always(function() {
            forms.hideSpinner();
        });
    });

    $(document).on("click", ".js-expire-tag-btn", function() {
        const data = $(this).parent().find(".active-tag-id").val();

        const params = {
            "data": data,
            "url": "/Person/ExpireTag"
        };

        forms.showSpinner("Saving...", false);

        dataaccess.post(params).done(function(results) {
            showResults(results);
        }).always(function() {
            forms.hideSpinner();
        });
    });
}

function showResults(results) {
    $("#TagModal .modal-body").html(results);
    $("#home-tag-list").html("").append($("#TagModal .modal-body").find("#HomeTagsSection").show());
    dateFormatter.initDatePicker();
}

export const tag = {
    init: init
};